
import {connect} from 'react-redux';
import axios from 'axios';
import store from "../../../../redux/store";
import { Platform} from "react-native"

import LoginScreen from '../LoginScreen';
import {typeExport} from "../../../../redux/store/type";
import {serviceActionSetState} from "../../splash/action/ActionSplashGetAllData";

const mapStateToProps = (state) => ({
    results: state.reducerLoginScreen.results,
    NoInternetDialog: state.reducerLoginScreen.NoInternetDialog,
    isLoading: state.reducerLoginScreen.isLoading,

    DataSplashScreen: state.reducerSplashGetAllData,
});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection) => dispatch(callWebservice(url, params, type, typeConnection)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),

})

const getDataDisatch = (dispatch, url, params, type, typeConnection) => {
    dispatch(serviceActionPending());
    axios(
        {
            url: typeExport.baseUrl + url + params,
            method: typeConnection,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            timeout: typeExport._TIMEOUT,
        }
    ).then(response => {
        switch (type) {

            case typeExport.TypegetDataLoginScreen:
                dispatch(serviceActionSuccess(response.data))

                break;


            default:
        }
    }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (url, params, type, typeConnection) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, url, params, type, typeConnection);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection);
        //         }
        //         else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //
        //         }
        //     }
        // )

                if (store.getState().reducerSplashGetAllData.Connection) {
                    getDataDisatch(dispatch, url, params, type, typeConnection);
                }
                else {
                    dispatch(serviceActionError("No Internet Connection"));

                }


    }
}


export const serviceActionPending = () => ({
    type:  typeExport.LoginScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.LoginScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.LoginScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.LoginScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
